<template lang="pug">
  .linegraphboard
    .linegraphboard_locations
      .linegraphboard_location
        mf_select(v-bind:value_type="get_location_value_list(0)", v-bind:selected="selected_locations[0]", v-bind:none_value="none_value", v-bind:disabled="is_disabled(0)" v-on:select_value_type="changeComparisonLocation(0, $event)")
      .linegraphboard_locdelimiter
        locdelimiter(v-bind:active='selected_locations[1]' v-on:click.native="changeComparisonLocation(1)")
      .linegraphboard_location
        mf_select(v-bind:value_type="get_location_value_list(1)", v-bind:selected="selected_locations[1]", v-bind:none_value="none_value", v-bind:disabled="is_disabled(1)", v-bind:fill="get_fill_color(1)" v-on:select_value_type="changeComparisonLocation(1, $event)")
      .linegraphboard_locdelimiter
        locdelimiter(v-bind:active='selected_locations[2]' v-on:click.native="changeComparisonLocation(2)")
      .linegraphboard_location
        mf_select(v-bind:value_type="get_location_value_list(2)", v-bind:selected="selected_locations[2]", v-bind:none_value="none_value", v-bind:disabled="is_disabled(2)", v-bind:fill="get_fill_color(2)" v-on:select_value_type="changeComparisonLocation(2, $event)")
      .linegraphboard_locdelimiter
        locdelimiter(v-bind:active='selected_locations[3]' v-on:click.native="changeComparisonLocation(3)")
      .linegraphboard_location
        mf_select(v-bind:value_type="get_location_value_list(3)", v-bind:selected="selected_locations[3]", v-bind:none_value="none_value", v-bind:disabled="is_disabled(3)", v-bind:fill="get_fill_color(3)" v-on:select_value_type="changeComparisonLocation(3, $event)")
      .linegraphboard_locdelimiter
        locdelimiter(v-bind:active='selected_locations[4]' v-on:click.native="changeComparisonLocation(4)")
      .linegraphboard_location
        mf_select(v-bind:value_type="get_location_value_list(4)", v-bind:selected="selected_locations[4]", v-bind:none_value="none_value", v-bind:disabled="is_disabled(4)", v-bind:fill="get_fill_color(4)" v-on:select_value_type="changeComparisonLocation(4, $event)")

    .linegraphboard_graph
      linegraph
    .linegraphboard_menu
      bottommenu(type='linegraph')
    .linegraphboard_closebutton
      closebutton(v-on:close="close")

</template>
<script>
  import {mapGetters, mapState, mapActions} from 'vuex';
  import _ from 'lodash';

  import BottomMenu from './bottommenu.vue';
  import Delim from './locdelimiter.vue';
  import LineGraph from './linegraph.vue';

  export default{
    data(){
      return {
        none_value: {
          name: '比較',
          value: 0,
          label: 'Comparison'
        },
        dummy_value: [{
          name: 'name1',
          value: 1234
        },
          {
            name: 'name2',
            value: 5678
          }]
      }
    },
    computed: {
      ...mapState([
        'lang',
        'selected',
        'size',
        'linegraph_color',
      ]),
      ...mapGetters([
        'get_locations',
      ]),
      locations(){
        return this.get_locations;
      },
      win_height(){
        return this.size.window.height;
      },
      selected_locations(){
        return this.selected.locations;
      }
    },
    watch: {
      'selected.mode': function(val){
        // Linegraphを開いた瞬間、追加Location等を全削除
        // ToDo: Storeの内容をここで操作すべきではない
        if( this.selected.locations[0] && /linegraph/.test(val)){
          this.selected.locations.splice(1, this.selected.locations.length - 1);
        }
      }
    },
    methods: {
      ...mapActions([
        'modifyLocations',
      ]),
      close: function(){
        this.$emit('close');
      },
      get_location_object_by_name(name){

        if( name ){
          let filtered = _.filter(this.locations, (o)=>{
            return o.value === name;
          });
          //console.log('get_location_object_by_name', name, filtered);
          return filtered[0];
        }else{
          return null;
        }

      },
      changeComparisonLocation(index, event){
        this.modifyLocations([index, event]);
      },
      get_location_value_list(index){
        if( this.selected_locations[index] ){
          return this.locations;
        }else{
          return _.filter(this.locations, (location) => {
            return this.selected_locations.indexOf(location.value) === -1;
          })
        }
      },
      get_fill_color(index){
        return this.linegraph_color[index];
      },
      is_disabled(index){
        if( index - 1 < 0)
          return false;
        return !this.selected_locations[index - 1];
      }
    },
    components: {
      bottommenu: BottomMenu,
      locdelimiter: Delim,
      linegraph: LineGraph
    }
  };
</script>
<style lang="sass">
  .linegraphboard
    background-color: rgba(255, 255, 255, 1)
    height: 100%
    position: relative
    &_locations
      padding: 20px
      display: flex
      align-items: center
      max-width: 1024px
      margin: 0 auto

    &_location
      flex: 1 1 1px
    &_locdelimiter
      margin: 0 20px
      flex: 0 0 20px
    &_graph
      height: calc( 100vh - 260px )
    &_menu
      position: absolute
      bottom: 0
      left: 0
      width: 100%

    &_closebutton
      position: absolute
      bottom: 80px
      right: 50%
      transform: translate(480px, 50%)
      width: 45px
      height: 45px

</style>